


































import { Vue, Component } from 'vue-property-decorator'
import Table, { Config, Pagination } from '../enroll/components/Table.vue'
import { StudentPhotoVModel } from '@/models/studentPhoto/studentPhoto'
import { getList, getPhoto, getZipByType } from '@/api/studentPhoto/studentPhoto'
import { notify } from '@/utils/notification'
import { download } from '@/utils/download'
import EditStatus from './components/EditStatus.vue'
import UploadStatus from './components/UploadStatus.vue'

@Component({
    components: { Table, EditStatus, UploadStatus }
})
export default class ProjectInstance extends Vue {
    //todo 修改本页面按钮的权限
    InstantData: StudentPhotoVModel[] = []
    InstantCount = 0
    showEditor = false
    showUploader = false
    selectedData: StudentPhotoVModel = {
        id: '',
        xm: '',
        account: '',
        ksh: '',
        zkzh: '',
        xuehao: '',
        ok: 0,
        xb: '',
        csny: '',
        sfzh: '',
        zymc: '',
        csmbh: '',
        xymc: '',
    }

    status: any[] = [
        { label: '全部', value: -1 },
        { label: '未采集', value: 0 },
        { label: '审核中', value: 1 },
        { label: '比对成功', value: 2 },
        { label: '比对失败', value: 3 },
        { label: '留存', value: 4 },
        { label: '放弃入学', value: 5 },
        { label: '特殊', value: 6 }
    ]
    selectdStatus: number = -1
    searchAccount: string = ""
    get Instantpagination(): Pagination {
        return {
            current: 1,
            pagesize: 10
        }
    }

    get InstantConfig(): Config {
        return {
            rowKey: 'id',
            total: this.InstantCount,
            selection: 'radio',
            maxHeight: 700,
            columns: [
                // { prop: 'id', label: 'ID', width: 80 },
                { prop: 'xm', label: '学生姓名', width: 100, fixed: 'left' },
                {
                    prop: 'ok',
                    label: '状态',
                    width: 100,
                    formatter: this.formatterStatus
                },
                {
                    prop: 'xb',
                    label: '性别',
                    width: 100,
                    formatter: this.formatterSex
                },
                { prop: 'ksh', label: '考生号', width: 300 },
                { prop: 'account', label: '校园卡号', width: 200 },
                { prop: 'xymc', label: '学院名称', width: 100 },
                {
                    prop: 'xuehao',
                    label: '学号',
                    width: 100
                },
                {
                    prop: 'option',
                    label: '操作',
                    type: {
                        type: 'buttonGroup',
                        group: [
                            {
                                event: 'downloadPic',
                                text: '下载照片',
                                right: '',
                                buttonType: 'success'
                            },
                            {
                                event: 'editStatus',
                                text: '修改状态',
                                right: '',
                                buttonType: 'success'
                            }
                        ],
                        style: 'group',
                        size: 'small'
                    },
                    width: 350,
                    fixed: 'right'
                }
            ]
        }
    }



    created() {
        this.loadData(this.Instantpagination)
    }

    formatterSex(celValue: number) {
        if (celValue == 1) {
            return '男'
        } else return '女'
    }

    formatterStatus(celValue: number) {
        switch (celValue) {

            case 0: return '未采集'
            case 1: return '审核中'
            case 2: return '比对成功'
            case 3: return '比对失败'
            case 4: return '留存'
            case 5: return '放弃入学'
            case 6: return '特殊'
        }
    }

    backToTable() {
        this.showEditor = false
    }
    backUploadToTable(){
        this.showUploader = false
    }
    saveSuccess() {
        this.showEditor = false
        this.loadData(this.Instantpagination)
    }
    saveStatusSuccess() {
        this.showUploader = false
        this.loadData(this.Instantpagination)
    }
    uploadStatus(){
        this.showUploader = true
    }
    async loadData(pagination: Pagination) {
        try {
            let limit = pagination.pagesize
            let offset = pagination.pagesize * (pagination.current - 1)
            const { rows, total } = await getList(limit, offset, this.selectdStatus, this.searchAccount)
            this.InstantCount = total
            this.InstantData = rows
        } catch (e) {
            notify('获取数据失败', e)
        }
        return this.InstantData
    }

    async onButtonClick($event: any) {
        switch ($event.event) {
            case 'downloadPic': {
                this.handleDownloadStdPid($event.row.id, $event.row.ksh)
                return
            }
            case 'editStatus': {
                this.showEditor = true
                this.selectedData = $event.row
                return
            }
            default:
                break
        }
    }
    async handleDownloadPhotoSelectd() {
        try {
            var zip = await getZipByType(this.selectdStatus)
            download(zip, `照片.zip`)
        } catch (e) {
            notify('下载照片失败', e)
        }
    }
    async refreshData() {
        await this.loadData(this.Instantpagination)
    }
    async handleDownloadStdPid(id: string, ksh: string) {
        try {
            var pic = await getPhoto(id)
            download(pic, `${ksh}.jpg`)
        } catch (e) {
            notify('下载照片失败', e)
        }

    }
}
